import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { BieMetricRow } from './types';
import { formatMoney } from './format';

type Props = {
  cards: BieMetricRow[];
};

const preferred = ['XB', 'XD', 'XE', 'XI', 'NETCONTRIBUTION'];

const ExecutiveCardsPanel: React.FC<Props> = ({ cards }) => {
  const selected = [
    ...cards.filter((x) => preferred.includes(x.metriccode)),
    ...cards.filter((x) => !preferred.includes(x.metriccode)),
  ].slice(0, 8);

  return (
    <Grid container spacing={2}>
      {selected.map((card) => (
        <Grid size = {{ xs:2, sm:6, md:3}} key={card.metriccode}>
          <Card elevation={2}>
            <CardContent>
              <Typography variant="caption" color="text.secondary">
                {card.metricgroup}
              </Typography>
              <Typography variant="subtitle2" sx={{ mt: 0.5 }}>
                {card.metricname}
              </Typography>
              <Typography variant="h5" sx={{ mt: 1, fontWeight: 700 }}>
                {formatMoney(card.resultvalue)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ExecutiveCardsPanel;
